export default __webpack_public_path__ + "media/images/new_year/destination_1-735c5042a218e75ff7c0dafa0d207865.jpg";